import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthProvider";
import Index from "./pages/Index";
import Dashboard from "./pages/Dashboard";
import BuildDiet from "./pages/BuildDiet";
import ViewDiet from "./pages/ViewDiet";
import AddMeal from "./pages/AddMeal";
import SuggestMeal from "./pages/SuggestMeal";
import AddWeight from "./pages/AddWeight";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Profile from "./pages/Profile";

const queryClient = new QueryClient();

const App = () => (
    <QueryClientProvider client={queryClient}>
        <AuthProvider>
            <TooltipProvider>
                <Toaster />
                <Sonner />
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Index />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/build-diet" element={<BuildDiet />} />
                        <Route path="/view-diet" element={<ViewDiet />} />
                        <Route path="/add-meal" element={<AddMeal />} />
                        <Route path="/add-weight" element={<AddWeight />} />
                        <Route path="/suggest-meal" element={<SuggestMeal />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/signin" element={<SignIn />} />
                        <Route path="/signup" element={<SignUp />} />
                    </Routes>
                </BrowserRouter>
            </TooltipProvider>
        </AuthProvider>
    </QueryClientProvider>
);

export default App;
